import React from 'react';
import Icon from '../../../components/AppIcon';

const OrganizersSection = ({ organizers }) => {
  const roleLabels = {
    chairs: 'Conference Chairs',
    organizers: 'Organizers'
  };

  const getInitials = (name) => {
    if (!name) return '?';
    return name?.split(' ')?.map(n => n?.[0])?.join('')?.toUpperCase()?.slice(0, 2);
  };

  return (
    <section className="py-4 md:py-6 bg-muted/30 rounded-lg">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-4 md:mb-5">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-secondary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="Users" size={20} className="text-secondary" />
          </div>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground">Conference Organizers</h2>
        </div>

        <div className="space-y-6 md:space-y-8">
          {Object.entries(organizers)?.map(([role, members]) => {
            if (!members || members?.length === 0) return null;
            return (
              <div key={role}>
                <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4 md:mb-6">
                  {roleLabels?.[role] || role}
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
                  {members?.map((member) => (
                    <div
                      key={member?.id}
                      className="bg-card border border-border rounded-lg shadow-elevation-1 p-4 md:p-6 hover:shadow-elevation-3 transition-all duration-250"
                    >
                      <div className="flex flex-col items-center text-center">
                        <div className="w-20 h-20 md:w-24 md:h-24 overflow-hidden mb-3 md:mb-4 border-2 border-primary/20 bg-muted flex items-center justify-center">
                          {member?.image ? (
                            <img
                              src={member?.image}
                              alt={member?.name}
                              className="w-full h-full object-cover"
                            />
                          ) : (
                            <span className="text-xl md:text-2xl font-semibold text-muted-foreground">
                              {getInitials(member?.name)}
                            </span>
                          )}
                        </div>
                        <h4 className="text-sm md:text-base font-semibold text-foreground mb-1">
                          {member?.name}
                        </h4>
                        <p className="text-xs md:text-sm text-muted-foreground caption mb-2">
                          {member?.institution}
                        </p>
                        {member?.department && (
                          <p className="text-xs text-foreground/70 caption mb-3">
                            {member?.department}
                          </p>
                        )}
                        <div className="flex items-center gap-2">
                          {member?.email && (
                            <a
                              href={`mailto:${member?.email}`}
                              className="w-8 h-8 bg-primary/10 flex items-center justify-center hover:bg-primary/20 transition-all duration-250"
                              aria-label={`Email ${member?.name}`}
                            >
                              <Icon name="Mail" size={14} className="text-primary" />
                            </a>
                          )}
                          {member?.website && (
                            <a
                              href={member?.website}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="w-8 h-8 bg-primary/10 flex items-center justify-center hover:bg-primary/20 transition-all duration-250"
                              aria-label={`Visit ${member?.name}'s website`}
                            >
                              <Icon name="Globe" size={14} className="text-primary" />
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OrganizersSection;
